import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../Firebase';
import { FiLock, FiMail, FiShield, FiAlertCircle } from 'react-icons/fi';
import { persistAdminAuth } from '../../utils/adminStorage';
import './AdminDashboard.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const isDefaultAdmin = email === 'admin@swaruphospital.com' && password === 'admin123';

    try {
      if (isDefaultAdmin) {
        try {
          await signInWithEmailAndPassword(auth, email, password);
        } catch (authErr) {
          console.warn('Firebase login unavailable, using offline admin fallback:', authErr);
        }
        persistAdminAuth(email, password);
        navigate('/admin/dashboard');
        return;
      }

      await signInWithEmailAndPassword(auth, email, password);
      persistAdminAuth(email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/invalid-credential') {
        setError('Invalid login credentials. Enter admin@swaruphospital.com / admin123 to auto-setup.');
      } else if (err.code === 'auth/user-not-found') {
        setError('Admin user not found. Use admin@swaruphospital.com / admin123 to auto-setup.');
      } else {
        setError(err.message || 'Authentication failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="login-overlay" />
      <div className="login-card-container">
        <div className="login-logo-header">
          <div className="login-logo-box">
            <FiShield className="login-logo-icon" />
          </div>
          <h2>Swarup Admin Portal</h2>
          <p>Sign in to manage services, doctors, and blog posts</p>
        </div>

        {error && (
          <div className="login-error-box">
            <FiAlertCircle className="error-icon" />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleLogin} className="login-form">
          <div className="login-input-group">
            <label htmlFor="email">Email Address</label>
            <div className="input-with-icon">
              <FiMail className="input-icon" />
              <input
                id="email"
                type="email"
                required
                placeholder="admin@swaruphospital.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="login-input-group">
            <label htmlFor="password">Password</label>
            <div className="input-with-icon">
              <FiLock className="input-icon" />
              <input
                id="password"
                type="password"
                required
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className="login-submit-btn">
            {loading ? 'Authenticating...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p>Default credentials: <strong>admin@swaruphospital.com</strong> / <strong>admin123</strong></p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
